import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  Alert
} from "react-bootstrap";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createBrowserHistory } from "history";
import { Breadcrumb as BreadcrumbComponent } from "../../../components";
import isEmpty from "lodash.isempty";
import CountryStateCity from "../../../components/countryStateCity/CountryStateCity";
import { get_review_list } from "../../../redux/actions/reviewActions";
import StarRatingComponent from "react-star-rating-component";

const history = createBrowserHistory();
let isvalid = 1,
  invalidphone = "",
  disabled = false,
  submitValue = "Save",
  isLoading = "false";
class ReviewList extends Component {
  componentWillMount() {
    let dealID =  this.props.dealID.split('-');
    if(parseInt(dealID[0])){
      this.props.get_review_list(dealID[0]);
    }else{
      this.props.get_review_list(this.props.dealID);
    }
  }

  componentWillReceiveProps(nextProps){
    if(this.props.dealID !== nextProps.dealID){
      let dealID =  nextProps.dealID.split('-');
      if(parseInt(dealID[0])){
        this.props.get_review_list(dealID[0]);
      }else{
        this.props.get_review_list(nextProps.dealID);
      }
    }
  }

  render() {
    let reviewRow;
    if (!isEmpty(this.props.reviewList)) {
      reviewRow = this.props.reviewList.map((review, index) => (
        <div>
          <div>{review.userFirstName}</div>
          <div>{review.review}</div>
          <div>
            <StarRatingComponent
              name="rate1"
              editing={false}
              starCount={5}
              value={review.rating}
            />
          </div>
        </div>
      ));
    }
    return <div>{this.props.reviewList && reviewRow}</div>;
  }
}

ReviewList.propTypes = {
  get_review_list: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  sendingData: state.reviewReducer.sendingData,
  reviewResponse: state.reviewReducer.reviewResponse,
  receivingReviewList: state.reviewReducer.receivingReviewList,
  reviewList: state.reviewReducer.reviewList
});
export default compose(
  withRouter, // IMPORTANT: witRouter is "needed here" to avoid blocking routing:
  connect(mapStateToProps, { get_review_list })
)(ReviewList);



// WEBPACK FOOTER //
// ./src/app/views/frontend/dashboard/ReviewList.js